import { Component, Input } from '@angular/core';
import { ReorderDetailsItem } from 'src/app/core/models';
import { ProductItemQuantityUserData } from 'src/app/core/store/order-wizard/order-wizard-data/order-wizard-data.model';

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss'],
})
export class ProductDetailsComponent {
  @Input() items!: (ReorderDetailsItem & ProductItemQuantityUserData)[];

  constructor() {}
}
